import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useGeoState, useGeoFetch } from '../../components/GeoProvider'
import ErrorMessage from '../../components/Layout/ErrorMessage'
import EmptyMap from '../../components/Map/emptyMap'
import Map from '../../components/Map'
import toolTipFormatter from './toolTipFormatter'
import MapLegend from './MapLegendHorizontalSurv'
import styles from './RSVMap.module.scss'
import moment from 'moment'
import ErrorLogs from '../../components/ErrorBoundary/errorlogs'
import { useAuthState } from '../../components/AuthProvider'
import { displayDate } from './dates'
const SurveillanceMap = ({ zoomLocation }) => {
  const { user } = useAuthState()
  const chartRef = useRef(null)
  const location = useLocation()
  const hash = location.hash
  const [getMapStates, setMapStates] = useState()
  const [errorCode, setErrorCode] = useState()
  const [errorMessage, setErrorMessage] = useState()
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
  const [getStateJson, setStateJson] = useState()
  const { mapOptions, regionSelected, setRegionSelected ,setDisplayDate} = useGeoState()

  if (hash) {
    if (hash.split('-').length > 1) {
      setRegionSelected(hash.split('-')[0].replace('#', ''))
    }
  }
   const { data: statesData, error: MapError } = useGeoFetch(
      '',
      '',
      'surveillance',
      `mapwithstats?geo_type=STATE&season=2025-26&disease=all&pos=0&lob=0`
    )
  
    useEffect(() => {
      if (statesData !== null && statesData !== undefined && statesData !== '') {
        if (statesData.response_code === 200) {
          var response = statesData.response_data
          let maxDateStamp = Math.max(
            ...Object.keys(response).map((member) => Date.parse(member))
          )
        
          setDisplayDate(moment(maxDateStamp).utc().format('YYYY-MM-DD'))

          setMapStates(response)
        } else {
          let er={"errormessage":statesData.response_message,
            "errorcode":statesData.response_code,
            "errorsubject":statesData.response_subject,
            "erroroccured":true
          }
          //setErrorOccuredValue(er)
        }
        //setStateLoadingValue(false)
      }
    }, [statesData, getMapStates])
  

  useEffect(() => {
    let url = `${window.location.origin}/covid/usStatesAll.json`
    fetch(url)
      .then(function (res) {
        return res.json()
      })
      .then(function (data) {
        setStateJson(data)
      })
      .catch(function (err) {
        console.log(err, ' error file usStatesAll.json')
      })
  }, [1])

  if (MapError || errorOccured) {
    return (
      <ErrorMessage
        errorCode={errorCode}
        errorMessage={errorMessage}
        errorSubject={errorSubject}
        errorDetails={errorMessage}
      />
    )
  }

  return (
    <div className={`${styles.base}`}>
      {regionSelected === 'state' && (
        <>
          {getMapStates !== undefined && getStateJson ? (
            <>
              <Map
                toolTipFormatter={toolTipFormatter}
                activeCbsasData={null}
                statesData={getMapStates}
                cbsaData={null}
                mapHeight="35vh"
                mapWidth="50vh"
                mapOptions={mapOptions}
                dynamicMapTitle={true}
                mapType="rsvmap"
                enableButtons={false}
                enableTooltip={false}
                chartRef={chartRef}
                mapDataType={0}
                stateJson={getStateJson}
                enableMouseTracking={false}
                dashboardType="Covid"
              />
              <MapLegend className={styles.mapLegend} />
            </>
          ) : (
            <EmptyMap
              mapHeight="30vh"
              mapWidth="60vh"
              stateJson={getStateJson}
            />
          )}
        </>
      )}
    </div>
  )
}

export default SurveillanceMap
